<template>
  <div>
    <b-row>
      <b-col cols="6">
        <div class="d-flex flex-column">
          <label for="" class="w-50">กำหนดโค้ดสำหรับใช้งาน</label>
          <div class="d-flex mt-2">
            <b-form-radio
              class=""
              :name="`isCodeRequired${type}`"
              v-model="formData.isCodeRequired"
              @change="changeCodeRequired"
              :value="false"
              >ไม่ต้องใช้โค้ด</b-form-radio
            >
            <b-form-radio
              class="mx-4"
              :name="`isCodeRequired${type}`"
              v-model="formData.isCodeRequired"
              :value="true"
              >ต้องใช้โค้ดเพื่อรับส่วนลด</b-form-radio
            >
          </div>
        </div>
      </b-col>
      <b-col cols="6">
        <InputText
          :textFloat="'โค้ดส่วนลด'"
          :placeholder="'กรุณาระบุโค้ด'"
          type="text"
          name="code"
          :disabled="!formData.isCodeRequired || !formData.isPublicCode"
          v-model="formData.code"
          :isValidate="v.form.code.$error"
          :v="v.form.code"
        />
      </b-col>
    </b-row>
    <b-row v-if="formData.isCodeRequired">
      <b-col cols="6">
        <div class="d-flex flex-column">
          <label for="" class="w-50">กำหนดรูปแบบโค้ด</label>
          <div class="d-flex mt-2">
            <b-form-radio
              :name="`isPublicCode${type}`"
              v-model="formData.isPublicCode"
              :value="true"
              >โค้ดสาธารณะ</b-form-radio
            >
            <b-form-radio
              class="mx-4"
              :name="`isPublicCode${type}`"
              v-model="formData.isPublicCode"
              @change="changeCodeRequired"
              :value="false"
              >โค้ดรายบุคคล</b-form-radio
            >
          </div>
        </div>
      </b-col>
      <b-col cols="6">
        <div class="h-100 d-flex align-items-end" v-if="!formData.isPublicCode">
          <div>
            <b-button class="btn-main" @click="handleCode">{{
              couponId > 0 ? "จัดการโค้ด" : "สร้างโค้ด"
            }}</b-button>
            <div v-if="noCode" class="btn-valid">กรุณาสร้างโค้ด</div>
          </div>
          <b-button
            class="btn-main"
            @click="viewCode"
            v-if="formatCode.couponList.length > 0"
            >ดูโค้ด</b-button
          >
        </div>
      </b-col>
    </b-row>

    <ModalGenCode
      ref="modalGenCode"
      @handleData="getFormatCode"
      @updateCouponList="getCouponList"
    />
    <ModalHistoryCode
      ref="modalHistoryCode"
      :couponId="couponId"
      :couponList="formatCode.couponList"
      :prefixCode="formatCode.prefix"
    />
  </div>
</template>

<script>
import ModalGenCode from "@/views/pages/promotion/components/ModalGenCode";
import ModalHistoryCode from "@/views/pages/promotion/components/ModalHistoryCode";
import InputText from "@/components/inputs/InputText";

export default {
  //   name: "SetupCode",
  components: {
    ModalGenCode,
    ModalHistoryCode,
    InputText,
  },
  props: {
    v: {
      required: true,
      type: [Object],
    },
    form: {
      required: true,
      type: [Object],
    },
    type: {
      required: true,
      type: Number,
    },
    couponId: {
      required: true,
      type: Number,
    },
    noCode: {
      required: false,
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      formData: {
        isCodeRequired: false,
        isPublicCode: true,
        code: "",
      },
      formatCode: {
        prefix: "",
        amount: 0,
        couponList: [],
      },
    };
  },
  methods: {
    changeCodeRequired(e) {
      this.formData.code = "";
    },
    handleCode() {
      if (this.formData.couponId > 0) {
        this.$refs.modalHistoryCode.show();
      } else {
        this.$refs.modalGenCode.show();
      }
    },
    viewCode() {
      this.$refs.modalHistoryCode.show();
    },
    getFormatCode(data) {
      this.formatCode = data;
    },
    getCouponList(list) {
      this.couponList = list;
    },
  },
  created() {
    this.formData = this.form;
  },
  watch: {
    formData: {
      handler(newVal) {
        this.$emit("updateSetupCode", newVal, this.formatCode);
      },
      deep: true,
    },
    "formatCode.couponList": function (e) {
      this.$emit("updateSetupCode", this.formData, this.formatCode);
    },
  },
};
</script>

<style scoped lang="scss">
label {
  color: #16274a;
  font-size: 16px;
  margin-bottom: 2px;
  font-weight: bold;
  width: 100%;
}

.btn-valid {
  color: #ff0000 !important;
  font-size: 14px;
  position: absolute;
}
</style>
